module.exports = __webpack_public_path__ + "static/Eko Nugroho-543caed74cac858b2ac18e4790d4eceb.jpg";